import { useEffect } from "react";
import { EDITION_BTG_LINK } from "@features/banner/Edition/utils/constants";
import { IS_PLAYWRIGHT } from "@util/constant";
import Cookies from "js-cookie";

/** Hook to use to redirect BT Homepage to BTI homepage. */
export const useHomepageRedirect = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (IS_PLAYWRIGHT) return;

    const country = Cookies.get("sph_user_country");
    const userPreferredVersion = Cookies.get("preferred_region");

    if (country === "SG") return;
    if (userPreferredVersion === "SG") return;

    const linkParams = new URLSearchParams({
      ref: "home-redirect",
    });
    const params = `?${linkParams?.toString()}`;

    const redirectUrl = `${EDITION_BTG_LINK}${params}`;
    window.location.href = redirectUrl;
  }, []);
};
